<h2 class="sub-header">{{ 'events.submissions.submission-form-settings.title' | translate | titlecase }}</h2>

<form #submissionForm="ngForm">
  <div class="mt-27">
    <label class="mr-10" for="page-title">{{ 'events.submissions.submission-form-settings.page-title' | translate | ucfirst }}</label>
    <input type="text" name="page-title" [(ngModel)]="formData.PageTitle" />
  </div>

  <div class="mt-27">
    <p-checkbox name="hide-event-type" [(ngModel)]="formData.HideEventType" [binary]="true"></p-checkbox>
    <label for="hide-event-type">
      {{ 'events.submissions.submission-form-settings.hide-event-type' | translate | ucfirst }}
    </label>
  </div>

  <div class="mt-27">
    <div>
      <label for="calendar-type">{{ 'events.submissions.submission-form-settings.calendar-type' | translate | ucfirst }}</label>
    </div>
    <p-select
      name="calendar-type"
      #calendarType
      [(ngModel)]="formData.CalendarType"
      [placeholder]="'common.select-dashes' | translate | titlecase"
      [options]="calendarTypeOptions"
    ></p-select>
  </div>

  <div class="mt-27">
    <p-checkbox name="require-login" [(ngModel)]="formData.RequireLogin" [binary]="true"></p-checkbox>
    <label class="mr-10" for="require-login">
      {{ 'events.submissions.submission-form-settings.require-login' | translate | ucfirst }}
    </label>
  </div>

  <div class="mt-27">
    <div>
      <label for="confirmation-message">{{
          'events.submissions.submission-form-settings.confirmation-message' | translate | ucfirst
        }}</label>
    </div>
    <textarea name="confirmation-message" [(ngModel)]="formData.ConfirmationMessage"></textarea>
  </div>
</form>

<div class="mct-flex mct-row mct-justify-end mct-items-stretch mct-gap-10">
  <wl-save-cancel-actions [isSaving]="isSaving" [isSaveDisabled]="submissionForm.invalid" (onSave)="save()" (onCancel)="cancel()">
  </wl-save-cancel-actions>
</div>
